<template>
	<div class="data-ingredient">
		<div class="page-header" style="margin-bottom:15px">区域设置</div>
		<div class="data-area">
		<span style="text-align:left;display:block;font-weight:400;color:rgba(145, 145, 145, 1)">
			设置开放注册区域
		</span>
		<el-row v-for="(item, index) in areaList" :key="index" style="text-align:left;margin-top: 10px;">
			<el-col :span="1" style="line-height:28px;">
				{{item.areaName}}
			</el-col>
			<el-col :span="16">
				<el-form
				 label-width="100px"
				>
					<el-form-item v-for="city in item.cityList" :key="city.cityName" :label="city.cityName" style="maring-bottom:10px">
						<el-switch
						 v-model="city.status"
						 active-color="#13ce66"
						 inactive-color="#DCDFE6"
						 :active-value="1"
						 :inactive-value="0"
						 @change="(nval)=>areaChange(nval,city.id)"
						>
						</el-switch>
						<span style="font-size:12px;display:inline-block;margin-left:12px">{{city.status==1?'开放':''}}</span>
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>
		</div>
	</div>
</template>
<script>
import { fetchGroupList,areaChangeStus } from '@/api/city'
export default {
	name: "KidAreaSet",
	data(){
		return {
			areaList: []
		}
	},
	created() {
		this.fetchGroupAreaList();
	},
	methods: {
		fetchGroupAreaList() {
			fetchGroupList().then(response=>{
				this.areaList = response.data;
			})
		},
		areaChange(nval,id) {
			const params = {id: id, status: nval}
			areaChangeStus(params).then(response=>{
				this.$message({
					message: '状态更改成功！',
					type: 'success'
				});
				this.fetchGroupAreaList();
			})
		}
	}
};
</script>
<style lang="scss" scoped>
 .data-area {
	 margin: 0 15px 15px 15px;
 }
</style>





// WEBPACK FOOTER //
// src/views/datacenter/components/eeopset/areaset/index.vue